import React from 'react'
import PropTypes from 'prop-types'
import Select from 'components/Utils/Select'

export default class ShareToSelectInput extends React.Component {
  static propTypes = {
    value: PropTypes.string,
    target: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
  }

  state = {
    options: [],
  }

  constructor(props) {
    super(props)

    this.id = `share_to_select_input_${Math.floor(Math.random() * 1e8).toString(
      16
    )}`
    this.state = {
      options: props.target.options,
    }

    // react-select-me only deals with the custom component but doesn't seem to
    // care about default values.
    // We're calling this on instanciation to ensure that our default value is always selected properly
    if (this.props.value) {
      this.props.onChange(this.props.value)
    }
  }

  handleSearch = searchString => {
    this.setState({
      options: this.props.target.options.filter(option =>
        option.label.toLowerCase().includes(searchString)
      ),
    })
  }

  componentDidMount() {
    const {
      target: { autofocus },
    } = this.props

    if (autofocus) {
      // The things we do to solve issues on a badly designed component... 😓
      const element = document.querySelector(`#${this.id} .dd__search`)
      if (element) {
        element.focus()
      }
    }
  }

  render() {
    const { target, value, extraProps, onChange, required = false } = this.props

    return (
      <Select
        className="width-full"
        required={required}
        searchable
        id={target.id}
        value={value || undefined}
        options={this.state.options}
        placeholder={`Pick a ${target.label}`}
        onSearch={this.handleSearch}
        listMaxHeight={300}
        onChange={onChange}
        {...extraProps}
      />
    )
  }
}
